export const formatDownloadSize = (size: number): string => {
  if (size > 1024) {
    return `${(size / 1024).toFixed(2)} MB`;
  }
  return `${size.toFixed(0)} KB`;
};
